import { colors } from '@/theme/colors';
import { SvgIconCommonProps } from './types/svg-icon-common-props';
export default function SavingsPiggyBank({
  className,
  fillPrimary = colors.neutral100,
  fillSecondary = colors.aqua50,
}: SvgIconCommonProps) {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="saving-piggy-coins-alternate 1" clipPath="url(#clip0_3811_2518)">
        <path
          id="Vector"
          d="M22.5 13.5C25.8137 13.5 28.5 10.8137 28.5 7.5C28.5 4.18629 25.8137 1.5 22.5 1.5C19.1863 1.5 16.5 4.18629 16.5 7.5C16.5 10.8137 19.1863 13.5 22.5 13.5Z"
          stroke={fillSecondary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_2"
          d="M46.5 21C46.5 22.5913 45.8679 24.1174 44.7426 25.2426C43.6174 26.3679 42.0913 27 40.5 27"
          stroke={fillPrimary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M12 13.5999C8.77277 15.6914 6.36984 18.8364 5.2 22.4999H1.5V34.4999H6.48C7.51569 36.3158 8.87866 37.9242 10.5 39.2439V44.9999C10.5 45.3977 10.658 45.7792 10.9393 46.0606C11.2206 46.3419 11.6022 46.4999 12 46.4999H15C15.3978 46.4999 15.7794 46.3419 16.0607 46.0606C16.342 45.7792 16.5 45.3977 16.5 44.9999V42.5179C20.3929 43.8196 24.6024 43.8274 28.5 42.5399V44.9999C28.5 45.3977 28.658 45.7792 28.9393 46.0606C29.2206 46.3419 29.6022 46.4999 30 46.4999H33C33.3978 46.4999 33.7794 46.3419 34.0607 46.0606C34.342 45.7792 34.5 45.3977 34.5 44.9999V39.2739C36.3504 37.8034 37.8492 35.9384 38.8872 33.815C39.9252 31.6916 40.4762 29.3633 40.5 26.9999C40.4647 24.3152 39.7588 21.6819 38.4465 19.3395C37.1342 16.9971 35.2571 15.02 32.986 13.5879"
          stroke={fillPrimary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_4"
          d="M16.5 15.0003C18.3654 14.077 20.4186 13.5967 22.5 13.5967C24.5814 13.5967 26.6346 14.077 28.5 15.0003"
          stroke={fillPrimary}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_3811_2518">
          <rect width="48" height="48" fill={fillPrimary} />
        </clipPath>
      </defs>
    </svg>
  );
}
